const minimumPasswordLength = 15;

export const testPasswordPolicy = (password: string): boolean =>
    password.length >= minimumPasswordLength;
